export const STORAGE_USER = `fever99`;
export const STORAGE_LOCATION = 'fever99_location'
export const STORAGE_PAYMENT_SESSION = 'fever99_payment_ID'